export default __webpack_public_path__ + "static/media/img-section-4-mobile-new.bbd9d5b9.jpg";